"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = exports.extractImagesKeys = exports.IMAGE_SIZES = void 0;
const IMAGE_FORMATS = ['jpg', 'webp'];
exports.IMAGE_SIZES = ['xxlarge', 'xlarge', 'large', 'medium', 'small', 'xsmall'];
const extractImagesKeys = (images) => {
    const keys = [];
    for (const SIZE of exports.IMAGE_SIZES) {
        const imagesSizes = images[SIZE];
        if (!imagesSizes)
            continue;
        for (const FORMAT of IMAGE_FORMATS) {
            const imageConfig = imagesSizes[FORMAT];
            if (!imageConfig)
                continue;
            keys.push(imageConfig.key);
        }
    }
    return keys;
};
exports.extractImagesKeys = extractImagesKeys;
var CountryCode;
(function (CountryCode) {
    CountryCode["AF"] = "AF";
    CountryCode["AX"] = "AX";
    CountryCode["AL"] = "AL";
    CountryCode["DZ"] = "DZ";
    CountryCode["AS"] = "AS";
    CountryCode["AD"] = "AD";
    CountryCode["AO"] = "AO";
    CountryCode["AI"] = "AI";
    CountryCode["AQ"] = "AQ";
    CountryCode["AG"] = "AG";
    CountryCode["AR"] = "AR";
    CountryCode["AM"] = "AM";
    CountryCode["AW"] = "AW";
    CountryCode["AU"] = "AU";
    CountryCode["AT"] = "AT";
    CountryCode["AZ"] = "AZ";
    CountryCode["BS"] = "BS";
    CountryCode["BH"] = "BH";
    CountryCode["BD"] = "BD";
    CountryCode["BB"] = "BB";
    CountryCode["BY"] = "BY";
    CountryCode["BE"] = "BE";
    CountryCode["BZ"] = "BZ";
    CountryCode["BJ"] = "BJ";
    CountryCode["BM"] = "BM";
    CountryCode["BT"] = "BT";
    CountryCode["BO"] = "BO";
    CountryCode["BA"] = "BA";
    CountryCode["BW"] = "BW";
    CountryCode["BV"] = "BV";
    CountryCode["BR"] = "BR";
    CountryCode["IO"] = "IO";
    CountryCode["BN"] = "BN";
    CountryCode["BG"] = "BG";
    CountryCode["BF"] = "BF";
    CountryCode["BI"] = "BI";
    CountryCode["KH"] = "KH";
    CountryCode["CM"] = "CM";
    CountryCode["CA"] = "CA";
    CountryCode["CV"] = "CV";
    CountryCode["KY"] = "KY";
    CountryCode["CF"] = "CF";
    CountryCode["TD"] = "TD";
    CountryCode["CL"] = "CL";
    CountryCode["CN"] = "CN";
    CountryCode["CX"] = "CX";
    CountryCode["CC"] = "CC";
    CountryCode["CO"] = "CO";
    CountryCode["KM"] = "KM";
    CountryCode["CG"] = "CG";
    CountryCode["CD"] = "CD";
    CountryCode["CK"] = "CK";
    CountryCode["CR"] = "CR";
    CountryCode["CI"] = "CI";
    CountryCode["HR"] = "HR";
    CountryCode["CU"] = "CU";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DK"] = "DK";
    CountryCode["DJ"] = "DJ";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["EC"] = "EC";
    CountryCode["EG"] = "EG";
    CountryCode["SV"] = "SV";
    CountryCode["GQ"] = "GQ";
    CountryCode["ER"] = "ER";
    CountryCode["EE"] = "EE";
    CountryCode["ET"] = "ET";
    CountryCode["FK"] = "FK";
    CountryCode["FO"] = "FO";
    CountryCode["FJ"] = "FJ";
    CountryCode["FI"] = "FI";
    CountryCode["FR"] = "FR";
    CountryCode["GF"] = "GF";
    CountryCode["PF"] = "PF";
    CountryCode["TF"] = "TF";
    CountryCode["GA"] = "GA";
    CountryCode["GM"] = "GM";
    CountryCode["GE"] = "GE";
    CountryCode["DE"] = "DE";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GR"] = "GR";
    CountryCode["GL"] = "GL";
    CountryCode["GD"] = "GD";
    CountryCode["GP"] = "GP";
    CountryCode["GU"] = "GU";
    CountryCode["GT"] = "GT";
    CountryCode["GG"] = "GG";
    CountryCode["GN"] = "GN";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HT"] = "HT";
    CountryCode["HM"] = "HM";
    CountryCode["VA"] = "VA";
    CountryCode["HN"] = "HN";
    CountryCode["HK"] = "HK";
    CountryCode["HU"] = "HU";
    CountryCode["IS"] = "IS";
    CountryCode["IN"] = "IN";
    CountryCode["ID"] = "ID";
    CountryCode["IR"] = "IR";
    CountryCode["IQ"] = "IQ";
    CountryCode["IE"] = "IE";
    CountryCode["IM"] = "IM";
    CountryCode["IL"] = "IL";
    CountryCode["IT"] = "IT";
    CountryCode["JM"] = "JM";
    CountryCode["JP"] = "JP";
    CountryCode["JE"] = "JE";
    CountryCode["JO"] = "JO";
    CountryCode["KZ"] = "KZ";
    CountryCode["KE"] = "KE";
    CountryCode["KI"] = "KI";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KG"] = "KG";
    CountryCode["LA"] = "LA";
    CountryCode["LV"] = "LV";
    CountryCode["LB"] = "LB";
    CountryCode["LS"] = "LS";
    CountryCode["LR"] = "LR";
    CountryCode["LY"] = "LY";
    CountryCode["LI"] = "LI";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["MO"] = "MO";
    CountryCode["MK"] = "MK";
    CountryCode["MG"] = "MG";
    CountryCode["MW"] = "MW";
    CountryCode["MY"] = "MY";
    CountryCode["MV"] = "MV";
    CountryCode["ML"] = "ML";
    CountryCode["MT"] = "MT";
    CountryCode["MH"] = "MH";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MU"] = "MU";
    CountryCode["YT"] = "YT";
    CountryCode["MX"] = "MX";
    CountryCode["FM"] = "FM";
    CountryCode["MD"] = "MD";
    CountryCode["MC"] = "MC";
    CountryCode["MN"] = "MN";
    CountryCode["ME"] = "ME";
    CountryCode["MS"] = "MS";
    CountryCode["MA"] = "MA";
    CountryCode["MZ"] = "MZ";
    CountryCode["MM"] = "MM";
    CountryCode["NA"] = "NA";
    CountryCode["NR"] = "NR";
    CountryCode["NP"] = "NP";
    CountryCode["NL"] = "NL";
    CountryCode["AN"] = "AN";
    CountryCode["NC"] = "NC";
    CountryCode["NZ"] = "NZ";
    CountryCode["NI"] = "NI";
    CountryCode["NE"] = "NE";
    CountryCode["NG"] = "NG";
    CountryCode["NU"] = "NU";
    CountryCode["NF"] = "NF";
    CountryCode["MP"] = "MP";
    CountryCode["NO"] = "NO";
    CountryCode["OM"] = "OM";
    CountryCode["PK"] = "PK";
    CountryCode["PW"] = "PW";
    CountryCode["PS"] = "PS";
    CountryCode["PA"] = "PA";
    CountryCode["PG"] = "PG";
    CountryCode["PY"] = "PY";
    CountryCode["PE"] = "PE";
    CountryCode["PH"] = "PH";
    CountryCode["PN"] = "PN";
    CountryCode["PL"] = "PL";
    CountryCode["PT"] = "PT";
    CountryCode["PR"] = "PR";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["BL"] = "BL";
    CountryCode["SH"] = "SH";
    CountryCode["KN"] = "KN";
    CountryCode["LC"] = "LC";
    CountryCode["MF"] = "MF";
    CountryCode["PM"] = "PM";
    CountryCode["VC"] = "VC";
    CountryCode["WS"] = "WS";
    CountryCode["SM"] = "SM";
    CountryCode["ST"] = "ST";
    CountryCode["SA"] = "SA";
    CountryCode["SN"] = "SN";
    CountryCode["RS"] = "RS";
    CountryCode["SC"] = "SC";
    CountryCode["SL"] = "SL";
    CountryCode["SG"] = "SG";
    CountryCode["SK"] = "SK";
    CountryCode["SI"] = "SI";
    CountryCode["SB"] = "SB";
    CountryCode["SO"] = "SO";
    CountryCode["ZA"] = "ZA";
    CountryCode["GS"] = "GS";
    CountryCode["ES"] = "ES";
    CountryCode["LK"] = "LK";
    CountryCode["SD"] = "SD";
    CountryCode["SR"] = "SR";
    CountryCode["SJ"] = "SJ";
    CountryCode["SZ"] = "SZ";
    CountryCode["SE"] = "SE";
    CountryCode["CH"] = "CH";
    CountryCode["SY"] = "SY";
    CountryCode["TW"] = "TW";
    CountryCode["TJ"] = "TJ";
    CountryCode["TZ"] = "TZ";
    CountryCode["TH"] = "TH";
    CountryCode["TL"] = "TL";
    CountryCode["TG"] = "TG";
    CountryCode["TK"] = "TK";
    CountryCode["TO"] = "TO";
    CountryCode["TT"] = "TT";
    CountryCode["TN"] = "TN";
    CountryCode["TR"] = "TR";
    CountryCode["TM"] = "TM";
    CountryCode["TC"] = "TC";
    CountryCode["TV"] = "TV";
    CountryCode["UG"] = "UG";
    CountryCode["UA"] = "UA";
    CountryCode["AE"] = "AE";
    CountryCode["GB"] = "GB";
    CountryCode["US"] = "US";
    CountryCode["UM"] = "UM";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VU"] = "VU";
    CountryCode["VE"] = "VE";
    CountryCode["VN"] = "VN";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["WF"] = "WF";
    CountryCode["EH"] = "EH";
    CountryCode["YE"] = "YE";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
